import React from 'react';
import { AppIcon } from '../atm.app-icon';
import { AvatarStyled } from './avatar.component.style';
export const AvatarImage = ({ src, size = 'large' }) => {
    return src ? React.createElement(AvatarStyled, { src: src, size: size }) : React.createElement(AppIcon.Avatar, { size: size });
};
